import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { LoginService } from '@pages/login/components/login.service';
import { AddressFormComponent } from '@shared/components/forms/address-form/address-form.component';
import { PersonalInformationFormComponent } from '@shared/components/forms/personal-information-form/personal-information-form.component';
import { Register } from '@shared/models/interfaces/register.interface';
import { UtmModel } from '@shared/models/interfaces/utmModel.interface';
import { UtilsService } from '@shared/providers/utils.service';
import { UtmService } from '@shared/providers/utm.service';
import { SetCanAccessRegisterComplete } from '@shared/store/canAccess/canAccess.actions';
import { RegisterCompanyFormComponent } from './register-company-form/register-company-form.component';
import { RegisterPersonalFormComponent } from './register-personal-form/register-personal-form.component';

@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.page.html',
  styleUrls: ['./new-user.page.scss'],
})
export class NewUserPage implements OnInit {
  public selectedRadioGroup = '1';
  @ViewChild('registerPersonalForm')
  registerPersonalForm: RegisterPersonalFormComponent;

  @ViewChild('addressForm') addressForm: AddressFormComponent;
  @ViewChild('registerCompanyForm') registerCompanyForm: RegisterCompanyFormComponent;
  @ViewChild('personalInformationsForm')
  personalInformationsForm: PersonalInformationFormComponent;

  public termsOfUseLink = environment.termsOfUseLink;
  public usagePolice = environment.usagePolice;
  public planId = environment.newUserPlanId;

  public formCheckBox: FormGroup;
  public formCoupon: FormGroup;

  get checkbox() {
    return this.formCheckBox.get('checkbox');
  }

  get couponCode() {
    return this.formCoupon.get('couponCode');
  }

  constructor(
    private loginService: LoginService,
    private utilsService: UtilsService,
    private router: Router,
    private formBuilder: FormBuilder,
    private store: Store,
    private translate: TranslateService,
    private utmService: UtmService
  ) {}

  ngOnInit() {
    this.formCheckBox = this.initializeFormTerms();
    this.formCoupon = this.initializeFormCoupon();
  }

  initializeFormTerms() {
    return this.formBuilder.group({
      checkbox: [false, Validators.compose([Validators.required])],
    });
  }

  initializeFormCoupon() {
    return this.formBuilder.group({
      couponCode: [''],
    });
  }

  async requestNewUser(data: { utmJson: UtmModel; user: Register }) {
    try {
      this.utilsService.presentLoading();
      await this.loginService.requestNewUser(data.user);
      this.utmHook(data.utmJson);
      this.utilsService.showToast('', `${this.translate.instant('NEW_USER.SUCCESSFULLY_REGISTERED')}`);
      this.store.dispatch(new SetCanAccessRegisterComplete(true));
      this.router.navigate(['novo-usuario', 'cadastro-realizado'], { queryParamsHandling: 'preserve' });
    } catch (error) {
      console.error(error);
      if (error.status === 409) {
        if (error.error.debugMessage && error.error.debugMessage.includes('user_document')) {
          this.utilsService.showToast('', `${this.translate.instant('NEW_USER.THERE_IS_ALREADY')}`);
        } else {
          this.utilsService.showToast('', `${this.translate.instant('NEW_USER.THERE_IS_ALREADY_A_USER')}`);
        }
      } else {
        this.utilsService.showToast('', error.error ? error.error.message : error.message);
      }
    } finally {
      this.utilsService.dismissLoading();
    }
  }

  async utmHook(utm: UtmModel) {
    try {
      await this.utmService.sendWebhook(utm);
    } catch (error) {
      if (!(error?.error?.error instanceof SyntaxError)) {
        console.error(error);
      }
    }
  }

  radioGroupChange(event) {
    if (event.detail.value !== this.selectedRadioGroup) {
      this.selectedRadioGroup = event.detail.value;
    }
  }

  parseResponsible(responsibleRawValue) {
    return {
      masterAdminResponsibleName: responsibleRawValue.userName,
      masterAdminResponsibleCpf: this.utilsService.unmask(responsibleRawValue.userDocument),
      masterAdminResponsibleEmail: responsibleRawValue.userEmail,
      masterAdminResponsiblePhone: this.utilsService.unmask(responsibleRawValue.userPhone),
    };
  }
}
